module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Medium.efe8e5ee.woff";